export const PHONE_MESSAGE = "Το τηλέφωνο γράφεται με αριθμούς, από 7 έως 15 ψηφία.";

export class PhoneError extends Error {
  constructor() {
    super(PHONE_MESSAGE);
    this.name = "PhoneError";
  }
}

/** Keep digits, spaces, and one leading +. Drop everything else as the person types. */
export function sanitizePhoneInput(value: string): string {
  let result = "";
  let plus = false;
  let digit = false;
  for (const char of value) {
    if (char >= "0" && char <= "9") {
      result += char;
      digit = true;
    } else if (char === " ") {
      result += " ";
    } else if (char === "+" && !plus && !digit) {
      result += "+";
      plus = true;
    }
  }
  return result;
}

/** Empty is missing. A value is digits, optional spaces, and an optional leading +. */
export function parsePhone(value: unknown): string | null {
  if (value == null || value === "") return null;
  if (typeof value !== "string") throw new PhoneError();
  const text = value.trim();
  if (!text) return null;
  const digits = text.replace(/\D/g, "");
  if (text.length > 40 || !/^\+?[\d ]+$/.test(text) || digits.length < 7 || digits.length > 15) throw new PhoneError();
  return text;
}
